"use strict";

import BaseProxyAcquisition from "@/proxies/base-proxy-acquisition";

/**
 * @class AuthChallengeProxy
 * @description Class used for challenging PKCE authentication.
 * @author Laurence A.
 * @version 1.0
 * @since March 20, 2023
 */
export default class AuthChallengeProxy {
  /**
   * @async
   * @function execute
   * @description Method used for generating redirect uri and authentication key
   * @param {Object} input - Input paramaters.
   * @param {String=} input.scope - Authentication scope
   * @param {String=} input.callbackPath - Callback path
   * @param {String=} input.connection - Auth connection (google / facebook)
   */
  async execute(input = {}) {
    const baseProxy = new BaseProxyAcquisition();
    const backendUrl = await baseProxy.getBackendUrl();
    const endpointUrl = `${backendUrl}/auth/challenge`;
    return baseProxy.postData(endpointUrl, input);
  }
}
